import { ref } from "vue";
import { defineStore } from "pinia";
import { Category } from "@/apps/shared/catalog/core/domain/Category/Category";
import {
  fromModelToStoredCategory,
  fromResponseToModel,
  StoredCategory,
} from "@/apps/shared/catalog/core/infrastructure/mapper/categoryTreeMapper";
import { CategoryResponse } from "@/apps/shared/catalog/core/infrastructure/repository/categoryTreeRepository";

const useCategoryStore = defineStore("category", () => {
  const categoryTree = ref<StoredCategory | null>(null);

  const getStoreCategoryTree = (category: CategoryResponse, parent?: Category) => {
    let dataToSave: StoredCategory;

    if (parent) {
      if (Array.isArray(category.children)) {
        parent.children = category.children.map((child: CategoryResponse) => fromResponseToModel(child));
      }
      dataToSave = fromModelToStoredCategory(parent.getRoot());
    } else {
      dataToSave = fromModelToStoredCategory(fromResponseToModel(category));
    }

    categoryTree.value = dataToSave;
  };

  const clearCategoryTree = () => (categoryTree.value = null);

  return {
    categoryTree,
    clearCategoryTree,
    getStoreCategoryTree,
  };
});

export default useCategoryStore;
